import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { translate } from '../../../../utils/util';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import ConfirmModal from '../../../../components/UI/ConfirmModal';
import PickingService from '../../../../services/PickingService';
import { Title, Button, BackButton, Input } from '../../../../components/UI/ComponentsUI';
import { getVision } from '../../../../services/auth';
import { VISIONS, ENUMS } from '../../../../utils/constants';
import PabReplanningService from '../../../../services/PABReplanningService';

const LinePicking = (props) => {
    const messageModal = useRef();
    let orderType = props.location?.state?.orderType;
    let vision = getVision();
    const [filterInput, setFilterInput] = useState({});
    const [messages, setMessages] = useState([]);
    const [textMessage, setTextMessage] = useState([]);

    const onChange = (event) => {
        onValueChange(event, filterInput, setFilterInput);
    };

    const onConfirm = () => {
        if (validateInputsRequired("formEndCall")) {
            validate();
        }
    }

    const validate = () => {
        const obj = {
            codes: filterInput.filter.split(" ").join("").split(','),
            type: orderType,
            vision: vision
        }

        if (orderType !== ENUMS.eOrderType.Picking.value) {
            setTextMessage(translate('line-picking:endCalls.message-alert'));
            messageModal.current.show();
        } else {
            props.validateOrder(obj, vision, (data) => {
                if (data.data?.length > 0) {
                    const defaultMessage = translate('line-picking:endCalls.message-alert-orderItem');
                    const message = defaultMessage.replace('{orderCodes}', data.data.join(', '))
                    setTextMessage(message)
                }
                else {
                    setTextMessage(translate('line-picking:endCalls.message-alert'));
                }
                messageModal.current.show();
            });
        }
    }

    const submit = () => {
        const obj = {
            codes: filterInput.filter.split(" ").join("").split(','),
            type: orderType,
            vision: vision
        }
        if (orderType === ENUMS.eOrderType.PabReplanning.value) {
            props.endPabCalls(obj, vision, (data) => {
                setMessages(data);
            });
        }
        else {
            props.endCalls(obj, vision, (data) => {
                setMessages(data);
            });
        }
    }

    return (
        <div id="formEndCall">
            <BackButton {...props} />
            <div className="container" style={{ paddingTop: 10 }}>
                <Title icon="mdi mdi-close-network-outline" label={translate('line-picking:endCalls:end-calls-logistics')} />
                <div style={{ paddingTop: 20, paddingBottom: 20 }}>
                    <Input
                        required
                        onChange={onChange}
                        placeholder={translate(vision === VISIONS.Fiasa ? 'line-picking:endCalls:input-order-item' : 'line-picking:endCalls:input-order')}
                        id="filter"
                        name="filter"
                        type="text"
                    />
                </div>
                <div className="col s12 center" style={{ paddingTop: '10px' }}>
                    <Button
                        onClick={() => onConfirm()}
                        full="true"
                        text={translate('line-picking:endCalls:endCall')}
                    />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', paddingTop: '15px' }}>
                    {messages.map((item) => (
                        <span key={item.code} className="fourth-text-color">
                            {item.code} - {item.message}
                        </span>
                    ))}
                </div>
                <ConfirmModal
                    ref={messageModal}
                    id="messageModalFinalize"
                    data={{ title: translate('validations:attention'), message: textMessage }}
                    onConfirm={submit}
                    btnCancel={translate('cancel', 'general')}
                    btnConfirm={translate('confirm', 'general')}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.linePickingReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        endCalls: (obj, vision, callback) => {
            dispatch(PickingService.endCalls(obj, vision, callback));
        },
        endPabCalls: (obj, vision, callback) => {
            dispatch(PabReplanningService.endCalls(obj, vision, callback));
        },
        validateOrder: (obj, vision, callback) => {
            dispatch(PickingService.validateOrder(obj, vision, callback));
        }
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LinePicking)));